// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.85.0-beta.dea41d56f',
  revision: 'dea41d56f',
  branch: 'develop',
  date: 'Mon, 23 Feb 2026 14:28:58 GMT'
};